<template>
  <section>
    <div class="selectBox isWindow">
      <div id="editProfileTitleRow">
        <p class="boldEditTitle">Edit Profile</p>
        <button class="closeEdit" @click="closeProfile"></button>
      </div>
      <div id="editProfile">
        <div id="editBox">
          <div class="titleAndEdit">
            <p class="boldEditTitle">Display Picture</p>
            <button class="editImageText">
              Edit
              <vue-dropzone
                ref="imgDropZone"
                id="edit-pic"
                :include-styling="false"
                :options="dropzoneOptions"
                @vdropzone-complete="setImage"
              ></vue-dropzone>
            </button>
          </div>
          <div class="profileImage">
            <img
              class="profilePicItself"
              :src="this.profile.profileImage"
              alt="profile Image"
            />
          </div>
        </div>
        <div id="editBox">
          <div class="titleAndEdit">
            <p class="boldEditTitle">Personal Information</p>
            <button v-if="!isEditing" class="editImageText" @click="startEdit">
              Edit
            </button>
            <button
              v-if="isEditing"
              class="editImageText cancelText"
              @click="cancelEdit"
            >
              Cancel
            </button>
          </div>
          <div class="showInfo">
            <!--input type="text" name="fname" v-model="firstName" />
                    <input type="text" name="lname" v-model="lastName" /-->
            <p v-if="!isEditing" class="infoText">
              <span style="font-weight: 550; font-size: 14px">Name:</span>
              {{ firstName }} {{ lastName }}
            </p>
            <p v-if="!isEditing" class="infoText">
              <span style="font-weight: 550; font-size: 14px"
                >Current Year:</span
              >
              {{ this.profile.year }}
            </p>
            <p v-if="!isEditing" class="infoText">
              <span style="font-weight: 550; font-size: 14px"
                >Current Major:</span
              >
              {{ this.profile.major }}
            </p>
            <div v-if="isEditing" class="editInfo">
              <input
                class="inputText"
                type="text"
                name="fname"
                v-model="firstName"
              />
              <input
                class="inputText"
                type="text"
                name="lname"
                v-model="lastName"
              />
            </div>
            <select v-if="isEditing" v-model="year" class="yearSelect">
              <option value="1st Year">1st Year</option>
              <option value="2nd Year">2nd Year</option>
              <option value="3rd Year">3rd Year</option>
              <option value="4th Year">4th Year</option>
              <option value="5th Year">5th Year</option>
              <option value="Graduate">Graduate</option>
              <option value="PhD">PhD</option>
            </select>
            <input
              v-if="isEditing"
              v-model="major"
              class="inputText longerInput"
              placeholder="Insert major here"
              maxlength="60"
            />
            <div v-if="isEditing" class="charLeft">{{ majorCharLeft }}</div>
          </div>
        </div>
        <div id="editBox">
          <div class="titleAndEdit">
            <p class="boldEditTitle">Bio</p>
            <button
              v-if="!isEditingBio && this.profile.bio"
              class="editImageText"
              @click="startBioEdit()"
            >
              Edit
            </button>
            <button
              v-if="!isEditingBio && !this.profile.bio"
              class="editImageText"
              @click="startBioEdit()"
            >
              Add
            </button>
            <button
              v-if="isEditingBio"
              class="editImageText cancelText"
              @click="cancelBioEdit()"
            >
              Cancel
            </button>
          </div>
          <div class="showInfo">
            <div style="display: flex; align-items: center">
              <p v-if="this.profile.bio && !isEditingBio">
                {{ this.profile.bio }}
              </p>
              <p v-else-if="!isEditingBio">Add a bio</p>
              <textarea
                v-if="isEditingBio"
                v-model="bio"
                class="inputBigText"
                placeholder="Insert bio here"
                maxlength="130"
                style="width: 295px; height: 80px"
              />
              <div v-if="isEditingBio" class="charLeft">{{ bioCharLeft }}</div>
            </div>
          </div>
        </div>
        <div id="editBox">
          <div class="titleAndEdit">
            <p class="boldEditTitle">Interests</p>
            <button
              v-if="interests.length != 0"
              @click="toggleInterest()"
              class="editImageText"
            >
              Edit
            </button>
            <button
              v-if="interests.length == 0"
              @click="toggleInterest()"
              class="editImageText"
            >
              Add
            </button>
          </div>
          <div class="showInfo interestList">
            <div class="leftPadding" v-if="interests.length == 0">
              Add Interests
            </div>
            <div v-for="(interest, index) in interests" :key="index">
              <Interest :icon="interest.unicode" :interest="interest.name" />
            </div>
          </div>
        </div>
      </div>
      <div id="saveProfile">
        <p v-if="feedback" class="feedback">{{ feedback }}</p>
        <button class="saveButton" @click="saveProfile">Save Profile</button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import db from "@/db";
import firebase from "@/firebase";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Interest from "@/components/profile/Interest";

export default {
  props: ["profile"],

  components: {
    vueDropzone: vue2Dropzone,
    Interest,
  },

  data: () => ({
    isEditing: false,
    isEditingBio: false,
    isEditingPI: false,
    initialFirst: "",
    initialLast: "",
    initialMajor: "",
    initialYear: "",
    initialBio: "",
    firstName: "",
    lastName: "",
    major: "",
    bio: "",
    year: "",
    majorCharLeft: 60,
    bioCharLeft: 130,
    interests: [],
    feedback: null,
    progressFriend: true,
    progressBio: true,
    progressInterests: true,
    progressGroup: true,
    progressPhotos: true,
    progressImage: true,
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      maxFilesize: 5,
      maxFiles: 10,
      duplicateCheck: true,
      addRemoveLinks: true,
      dictDefaultMessage: "Edit Image",
      previewsContainer: false,
    },
  }),

  mounted() {
    this.firstName = this.profile.firstName ? this.profile.firstName : "";
    this.lastName = this.profile.lastName ? this.profile.lastName : "";
    this.major = this.profile.major ? this.profile.major : "";
    this.bio = this.profile.bio ? this.profile.bio : "";
    this.year = this.profile.year ? this.profile.year : "";
    this.interests = this.profile.interests ? this.profile.interests : [];
  },

  watch: {
    major() {
      this.majorCharLeft = 60 - this.major.length;
    },
    bio() {
      this.bioCharLeft = 130 - this.bio.length;
    },
  },

  computed: {
    ...mapState("user", ["user"]),
    ...mapState("profile", ["isEditingProfile"]),
  },

  methods: {
    saveProfile() {
      this.checkProgress();
      var currentProgressBar = this.user.progressBar;

      if (!this.progressBio && this.initialBio != this.bio) {
        currentProgressBar.bio = true;
      }
      if (this.firstName.length + this.lastName.length > 30) {
        this.feedback = "First and last name cannot be more than 30 characters";
        return;
      }
      if (
        this.user.profileImage ==
        "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultUserImage%2FdefaultUserImage.jpeg?alt=media&token=d0140e78-d883-4a02-9827-82a89596eb6c"
      ) {
        //let firstImgChange = false;
        db.collection("schools")
          .doc(this.user.school_id)
          .get()
          .then((doc) => {
            var profileImageCount = doc.data().profileImageCount;

            db.collection("users")
              .doc(this.user.id)
              .update({
                profileImageNumber: profileImageCount,
              });

            db.collection("schools")
              .doc(this.user.school_id)
              .update({
                profileImageCount: firebase.firestore.FieldValue.increment(1),
              });
          });
      }
      if (!this.progressInterests && this.user.interests.length == 0) {
        currentProgressBar.interests = true;
      }

      db.collection("users")
        .doc(firebase.auth().currentUser.uid)
        .update({
          firstName: this.firstName,
          lastName: this.lastName,
          year: this.year,
          major: this.major,
          bio: this.bio,
          firstNameKeywords: this.addFirstNameKeyWords(this.firstName),
          lastNameKeywords: this.addLastNameKeyWords(this.lastName),
          progressBar: currentProgressBar,
        });
      this.profile.firstName = this.firstName;
      this.profile.lastName = this.lastName;
      this.profile.major = this.major;
      this.profile.bio = this.bio;
      this.profile.year = this.year;
      this.$store.commit("profile/setIsEditingProfile", false);
    },
    addFirstNameKeyWords(name) {
      var letters = [];
      var firstNameKeywords = [];
      var userName = name.split(" ");
      for (var i = 0; i < userName.length; i++) {
        var word = userName[i];
        for (var l = 1; l < word.length + 1; l++) {
          firstNameKeywords.push(word.substring(0, l).toLowerCase());
        }
      }
      for (var k = 1; k < name.length + 1; k++) {
        letters.push(name.substring(0, k).toLowerCase());
      }
      letters = firstNameKeywords.concat(letters);
      letters = letters.filter((v, i, a) => a.indexOf(v) === i);
      return letters;
    },
    addLastNameKeyWords(name) {
      var letters = [];
      var lastNameKeywords = [];
      var userName = name.split(" ");
      for (var i = 0; i < userName.length; i++) {
        var word = userName[i];
        for (var l = 1; l < word.length + 1; l++) {
          lastNameKeywords.push(word.substring(0, l).toLowerCase());
        }
      }
      for (var k = 1; k < name.length + 1; k++) {
        letters.push(name.substring(0, k).toLowerCase());
      }
      letters = lastNameKeywords.concat(letters);
      letters = letters.filter((v, i, a) => a.indexOf(v) === i);
      return letters;
    },
    closeProfile() {
      this.$store.commit("profile/setIsEditingProfile", false);
      console.log(this.isEditingProfile);
    },
    async setImage(file) {
      const storageRef = firebase.storage().ref();
      // If is an image
      if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
        const fileRef = storageRef.child(`profileImages/${file.name}.png`);
        await fileRef.put(file);
        const downloadURL = await fileRef.getDownloadURL();
        await db
          .collection("users")
          .doc(firebase.auth().currentUser.uid)
          .update({
            profileImage: downloadURL,
          });
        this.profile.profileImage = downloadURL;
      }
    },
    startEdit() {
      this.initialFirst = this.firstName;
      this.initialLast = this.lastName;
      this.initialMajor = this.major;
      this.initialYear = this.year;
      this.isEditing = true;
    },
    cancelEdit() {
      this.firstName = this.initialFirst;
      this.lastName = this.initialLast;
      this.major = this.initialMajor;
      this.year = this.initialYear;
      this.isEditing = false;
    },
    startBioEdit() {
      this.initialBio = this.bio;
      this.isEditingBio = true;
    },
    cancelBioEdit() {
      this.bio = this.initialBio;
      this.isEditingBio = false;
    },
    startPIedit() {
      this.isEditingPI = true;
    },
    cancelPIedit() {
      this.isEditingPI = false;
    },
    toggleInterest() {
      this.$store.commit("profile/setIsEditingInterest", true);
      this.initProfile();
    },
    checkProgress() {
      db.collection("users")
        .doc(firebase.auth().currentUser.uid)
        .get()
        .then((doc) => {
          if (!doc.data().progressBar.interests) {
            this.progressInterests = false;
          }
          if (!doc.data().progressBar.bio) {
            this.progressBio = false;
          }
          if (!doc.data().progressBar.photos) {
            this.progressPhotos = false;
          }
          if (!doc.data().progressBar.joinGroup) {
            this.progressGroup = false;
          }
          if (!doc.data().progressBar.addFriend) {
            this.progressFriend = false;
          }
          if (!doc.data().progressBar.profileImage) {
            this.progressImage = false;
          }
        });
    },
  },
};
</script>

<style scoped>
#backgroundClick {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
}
#editProfileTitleRow {
  top: 0;
  width: 100%;
  height: 100px;
  border-bottom: lightgrey solid thin;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 3;
}
#editProfile {
  height: fit-content;
  overflow: auto;
  margin-bottom: 60px;
  z-index: 3;
}
.closeEdit {
  position: absolute;
  right: 10px;
  height: 40px;
  width: 40px;
  border: none;
  border-radius: 50%;
  background-image: url("../../assets/closeEdit.svg");
  background-color: #e0e0e0;
  cursor: pointer;
  z-index: 3;
}
.closeEdit:hover {
  background-color: #cacaca;
}
.closeEdit:active {
  transform: scale(0.9);
}
#saveProfile {
  width: 100%;
  height: 60px;
  padding: 10px;
  border-top: lightgrey solid thin;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.profileImage {
  width: 200px;
  height: 200px;
  min-height: 130px;
  min-width: 130px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  margin: 10px;
}
.leftPadding {
  padding-left: 25px;
}
.selectBox {
  background-color: white;
  width: 700px;
  height: 600px;
  border-radius: 10px;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  z-index: 2;
}
.selectBox:hover {
  overflow-y: overlay;
}
.infoText {
  font-size: 16px;
}
.interestTitle {
  font-size: 20px;
  color: black;
  font-weight: 550;
  margin: 5px;
}
.interestContainer {
  display: inline-block;
  margin: 2px 2px 5px 10px;
}
.interestCountHover {
  border: 1px solid #f0f0f0;
  box-shadow: 1px 1px 6px #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  font-size: 20px;
  width: 100%;
  z-index: 100;
}
.editRow {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin: 10px 30px 10px 30px;
}
.saveButton {
  width: 100%;
  height: 100%;
  color: rgb(9, 132, 227);
  font-weight: 600;
  font-size: 18px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  background-color: #0fb9b150;
}
.saveButton:hover {
  background-color: #0fb9b190;
}
.saveButton:active {
  transform: scale(0.97);
}
.boldEditTitle {
  font-size: 20px;
  color: black;
  font-weight: bold;
}
.editImageText {
  color: rgb(9, 132, 227);
  cursor: pointer;
  border-radius: 5px;
  background-color: transparent;
  border: none;
  height: 35px;
  font-size: 16px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.editImageText:hover {
  background-color: rgb(230, 230, 230);
}
.editImageText:active {
  background-color: rgb(214, 214, 214);
}
.cancelText {
  width: 70px !important;
}
#editBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.titleAndEdit {
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.editPhotoPamphlet {
  display: flex;
  flex-direction: row;
}
.addProfileImages {
  width: 300px;
  height: 118px;
}
.profileImages {
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
}
.editPhotoBox {
  height: 150px !important;
  width: 150px !important;
  margin-right: 1%;
  overflow: hidden;
  object-fit: cover;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  background-color: black;
}
.showInfo {
  width: 90%;
  font-size: 17px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.interestList {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
  padding-bottom: 10px;
  padding-left: 10px;
}
#edit-pic {
  position: absolute;
  top: 64px;
  right: 10px;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;

  height: 35px;
  width: 50px;
  cursor: pointer;
  background-color: transparent;
}

#edit-pic .dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none;
}

#edit-pic .dz-filename,
.dz-size {
  display: none;
}
.editInfo {
  width: 53%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.inputText {
  padding: 10px;
  border: thin rgb(192, 192, 192) solid;
  border-radius: 5px;
  background-color: rgb(238, 238, 238);
  outline: none;
}
.inputText:hover {
  background-color: rgb(230, 230, 230);
}
.longerInput {
  margin-top: 8px;
  width: 53% !important;
}
.inputBigText {
  padding: 10px;
  border: thin rgb(192, 192, 192) solid;
  color: black;
  border-radius: 5px;
  background-color: rgb(238, 238, 238);
  outline: none;
  width: 53%;
  resize: none;
}
.yearSelect {
  width: 53%;
  height: 35px;
  padding-left: 10px;
  margin-top: 8px;
  display: inline-block;
  border: thin rgb(192, 192, 192) solid;
  outline: none;
  background: #eeeeee;
  border-radius: 5px;
  appearance: none;
  background-image: url("../../assets/dropdown.png"); /*linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%)*/
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.yearSelect:hover {
  background-color: rgb(230, 230, 230);
}
</style>
